import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { SupabaseClient } from '@supabase/supabase-js';

/**
 * Sets up automatic token refresh for Supabase using Firebase tokens
 * This ensures the Supabase client always has a valid token
 */
export const setupAuthTokenRefresh = (supabaseClient: SupabaseClient) => {
  // Initial setup
  refreshSupabaseToken(supabaseClient);
  
  // Listen for auth state changes
  FirebaseAuthentication.addListener('authStateChange', async (event) => {
    if (event.user) {
      // User signed in, refresh token
      refreshSupabaseToken(supabaseClient);
    } else {
      // User signed out, clear session
      await supabaseClient.auth.signOut();
    }
  });
};

/**
 * Refreshes the Supabase token using the current Firebase token
 */
const refreshSupabaseToken = async (supabaseClient: SupabaseClient) => {
  try {
    // Get current Firebase user
    const result = await FirebaseAuthentication.getCurrentUser();
    if (!result.user) return;
    
    // Get Firebase ID token
    const tokenResult = await FirebaseAuthentication.getIdToken();
    if (!tokenResult.token) return;
    
    // Set session with custom token
    await supabaseClient.auth.setSession({
      access_token: tokenResult.token,
      refresh_token: '',
    });
    
    console.log('Supabase token refreshed');
  } catch (error) {
    console.error('Error refreshing Supabase token:', error);
  }
};
